import { useMemo, useEffect, useState } from "react";
import {
  ThemeProvider as MUIThemeProvider,
  type PaletteMode,
} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { SnackbarProvider } from "notistack";
import { createAppTheme } from "../lib/theme";
/**
 * Componente interno que sincroniza Material-UI con next-themes
 *
 * NOTA: La licencia de MUI X Pro se configura en app/components/MuiXLicense.tsx
 * siguiendo las mejores prácticas recomendadas por MUI.
 */
function MUIThemeSync({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  // Crear tema de MUI basado en next-themes
  const muiTheme = useMemo(() => {
    if (!mounted) {
      // Modo por defecto durante SSR
      return createAppTheme("light");
    }
    // Determinar el modo actual
    const mode: PaletteMode = "light";
    return createAppTheme(mode);
  }, [mounted]);
  return (
    <MUIThemeProvider theme={muiTheme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        autoHideDuration={4000}
      >
        {children}
      </SnackbarProvider>
    </MUIThemeProvider>
  );
}
/**
 * ThemeProvider principal que integra next-themes con Material-UI
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <MUIThemeSync>{children}</MUIThemeSync>;
}
